import { gql } from "@apollo/client";

export const REFERENCES_CATEGORIES_QUERY = gql`
  query ReferenceCategories($scenarioId: ID!, $originId: ID) {
    data(scenarioId: $scenarioId, originId: $originId) {
      referenceCategories {
        items {
          id
          code
          name
          enabled
          references {
            id
            value
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
          __typename
        }
      }
    }
  }
`;
